import { Button, FlexRowCenter, OverflowText, Text } from "designSystem/index";
import React from "react";
import CssColumnGrid from "../../CssColumnGrid";

export default () => {
	return (
		<CssColumnGrid columns={2}>
			<Text semiBold text="Normal" />
			<Text semiBold text="Overflow" />
			<Button design="primary" title="Tooltip Text">Button</Button>
			<FlexRowCenter maxWidth={100}>
				<Button
					design="primary"
					fullWidth
					hideOverflow
				>
					<OverflowText text="I have a very long name" />
				</Button>
			</FlexRowCenter>
		</CssColumnGrid>
	);
};